import React from "react";
import {
  Box,
  Stack,
  Typography,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CustomSkeleton from "../../../components/custom-skeleton/CustomSkeleton";

const CarePlanWidgetSkeleton: React.FC = () => {
  return (
    <Box
      p={{ md: 4, xs: "2rem 1rem" }}
      borderRadius={"8px 64px 16px 16px"}
      bgcolor="#ffffff"
      maxWidth={1366}
      width="100%"
      mx="auto"
    >
      <Box maxWidth={996} m="0 auto">
        {/* Header */}
        <Stack spacing={2}>
          <CustomSkeleton variant="text" width={300} height={32} />
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            gap={2}
          >
            <CustomSkeleton variant="circular" width={48} height={48} />
            <CustomSkeleton variant="text" width={160} height={16} />
            <CustomSkeleton variant="text" width="80%" height={40} />
          </Box>
        </Stack>

        {/* Progress */}
        <Box my={2} p={2} border="1px solid #d1d1d1" borderRadius="12px">
          <CustomSkeleton
            variant="text"
            width={120}
            height={20}
            sx={{ mb: 1 }}
          />
          <LinearProgress
            variant="indeterminate"
            sx={{
              height: 10,
              borderRadius: 8,
              backgroundColor: "#EAF0F0",
              mb: 1,
              "& .MuiLinearProgress-bar": {
                borderRadius: 8,
                backgroundColor: "#d1d1d1",
              },
            }}
          />
          <CustomSkeleton variant="text" width={220} height={16} />
        </Box>

        {/* Activity list */}
        <List disablePadding sx={{ mb: 2 }}>
          <ListItem sx={{ px: 0, py: 1 }}>
            <ListItemText
              primary={
                <Typography variant="bodySmall" fontWeight={600}>
                  <CustomSkeleton width={100} height={20} />
                </Typography>
              }
            />
            <Box display="flex" alignItems="center" gap={2}>
              <CustomSkeleton width={50} height={20} />
            </Box>
          </ListItem>

          {Array.from({ length: 4 }).map((_, idx) => (
            <ListItem
              key={idx}
              sx={{
                px: 0,
                py: 2,
                borderBottom: idx === 3 ? "none" : "1px solid #D1D1D1",
              }}
            >
              <Box display="flex" flex={1} gap={2}>
                <CustomSkeleton
                  variant="rectangular"
                  width={60}
                  height={60}
                  sx={{ borderRadius: 1 }}
                />
                <Box>
                  <CustomSkeleton variant="text" width={200} height={20} />
                  <CustomSkeleton variant="text" width={100} height={16} />
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                minWidth={100}
                justifyContent="flex-end"
                gap={1.5}
              >
                <CustomSkeleton variant="circular" width={16} height={16} />
                <CustomSkeleton variant="text" width={30} height={20} />
              </Box>
            </ListItem>
          ))}
        </List>

        {/* CTA */}
        <Box display="flex" justifyContent="center" mt={3}>
          <CustomSkeleton
            variant="rectangular"
            width={160}
            height={40}
            sx={{ borderRadius: "20px" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CarePlanWidgetSkeleton;
